class CartCounter {

	static animationTime = 500;

	constructor() {
		this.$el = jQuery( '.CartCounter' );
		this.$counterEl = jQuery( '.CartCounterValue', this.$el );
		this.$widget = jQuery( '.cart-widget', this.$el );
		this.$toggleBtn = jQuery( '[data-cart-widget-toggle]', this.$el );
		this._counter = 0;
		this.BaseURL = window.WPShopify.shop_url;
		this.ajaxURL = window.WPShopify.ajax_url;

		this.isShopify = window.location.href.indexOf( this.BaseURL ) === 0;

		this.$forms = jQuery( 'form[action="/cart/add"]' );
		this.$bundleRadios = jQuery( '.product-single-upsells input[name="upsell_option"]' );
		this.$tieredOptions = this.$bundleRadios.filter( '[data-upsell-type="tiered"]' );
		this.tierQuantities = this.$tieredOptions.map( ( ind, el ) => {
			return parseInt( el.getAttribute( 'data-number-of-items' ) || 1, 10 )
		} ).get().sort();

		this.$selectedBundleItem = this.$bundleRadios.filter( ':checked' );
		this.$quantityInputs = jQuery( 'form[action="/cart/add"] input[name="quantity"]' );

		// this.$formSubmitBtn = this.$forms.

		this.upsellsJson = this.$el.attr( 'data-cart-upsells' );
		this.upsellHandles = this.upsellsJson ? JSON.parse( this.upsellsJson ) : [];

		this.addToCartSettings = {
			addToCartBtnLabel: 'Add to Bag',
			addedToCartBtnLabel: 'Thank you!',
			addingToCartBtnLabel: 'Adding...',
			soldOutBtnLabel: 'Sold Out',
			howLongTillBtnReturnsToNormal: 2000,
			addToCartBtnSelector: '[type="submit"]',
			addToCartBtnPriceSelector: '[data-submit-button-price]',
		};

		if ( this.$el.length ) {
			this.renderWidget();
			this.refresh();
			this.initUpsells();
			this.initEvents();
		}

	}

	initEvents() {
		this.$toggleBtn.on( 'click', this.toggleWidgetOpened.bind( this ) );

		this.$itemsWrapper.on( 'click', '[data-remove-cart-item]', this.handleRemoveCartItem.bind( this ) );
		this.$forms.on( 'submit', this.handleAddToCartFormSubmit.bind( this ) );

		this.$bundleRadios.on( 'change', this.updateSubmitButtonUI.bind( this ) );
		this.$quantityInputs.on( 'wpshopify.quantityChanged', this.handleQuantityChange.bind( this ) );

		this.$el.on( 'click', '[data-cart-widget-close]', this.handleCloseWidget.bind( this ) );

		this.$el.on( 'click', '[data-add-upsell-to-cart]', this.handleAddToCartUpsell.bind( this ) );

		jQuery( document ).on( 'click', '[data-add-to-cart]', this.handleAddToCart.bind( this ) );

		jQuery( document ).on( 'wpshopify.block_loaded', this.checkAvailabilityInBlock.bind( this ) );

		this.checkAvailabilityForButtons();

	}

	checkAvailabilityInBlock( event, el, blockId ) {
		console.log( 'checkAvailabilityInBlock', el );
		if ( el instanceof HTMLElement ) {
			this.checkAvailabilityForButtons( el );
		} else {
			this.checkAvailabilityForButtons( document );
		}
	}

	checkAvailabilityForButtons( root = document ) {
		const $buttonsToCheckAvailabilityFor = jQuery( '[data-product-availability-handle]', root );
		$buttonsToCheckAvailabilityFor.prop( 'disabled', true );

		$buttonsToCheckAvailabilityFor.each( ( index, el ) => {
			this.checkAvailabilityForAddToCartBtn( el );
		} );

	}

	checkAvailabilityForAddToCartBtn( btnEl ) {

		const $btn = jQuery( btnEl );
		const productHandle = $btn.attr( 'data-product-availability-handle' );
		const variantId = parseInt( $btn.attr( 'data-add-to-cart' ), 10 ) || 0;
		const $btnCaption = $btn.find( '[data-submit-button-text]' );
		const $btnPrices = $btn.find( '[data-submit-button-price]' );
		$btnPrices.fadeIn( 0 );

		if ( !variantId ) {
			return;
		}

		jQuery.getJSON( `${ this.BaseURL }/products/${ productHandle }.js`, ( response ) => {

			$btn.prop( 'disabled', false );

			if ( response && Array.isArray( response.variants ) ) {
				// lets iterate over variants
				let available = response.variants.reduce( ( result, variantObj ) => {
					if ( variantObj.inventory_policy === 'continue' ) {
						result = true;
					}
					if ( variantObj.id === variantId && variantObj.available ) {
						result = true;
					}
					return result;
				}, false );

				if ( available ) {
					if ( $btnCaption.length ) {
						$btnCaption.text( this.addToCartSettings.addToCartBtnLabel );
					} else {
						$btn.text( this.addToCartSettings.addToCartBtnLabel );
					}

					$btn.attr( 'data-available', true );
					return true;
				}
			}

			$btnPrices.fadeIn( 100 );

			if ( $btnCaption.length ) {
				$btnCaption.text( this.addToCartSettings.soldOutBtnLabel );
			} else {
				$btn.text( this.addToCartSettings.soldOutBtnLabel );
			}


		} );
		/* this.getJsonp( `${ this.BaseURL }/products/${ productHandle }.json`, ( response ) => {

			$btn.prop( 'disabled', false );

			if ( response.product && response.product && Array.isArray( response.product.variants ) ) {
				// lets iterate over variants
				let available = response.product.variants.reduce( ( result, variantObj ) => {
					if ( variantObj.inventory_policy === 'continue' ) {
						result = true;
					}
					if ( variantObj.id === variantId && variantObj.inventory_quantity > 0 ) {
						result = true;
					}
					return result;
				}, false );

				if ( available ) {
					$btn.text( this.addToCartSettings.addToCartBtnLabel );
					$btn.attr( 'data-available', true );
					return true;
				}
			}

			$btn.text( this.addToCartSettings.soldOutBtnLabel );

		} ); */

	}

	handleAddToCartFormSubmit( event ) {

		event.preventDefault();
		event.stopPropagation();

		const $form = jQuery( event.currentTarget );
		const $quantity = $form.find( 'input[name="quantity"]' );
		const quantity = parseInt( $quantity.val(), 10 );
		const $variantIdInput = $form.find( 'input[name="current_variant_id"]' );
		const currentProductVariantId = parseInt( $variantIdInput.val(), 10 ) || 0;

		// this one is necessary to be able to dynamically update variant id in bundles\tiers from this on to Currently selected if product has variants.
		const $firstPrimaryVariantIdInput = $form.find( 'input[name="product_main_first_variant_id"]' );
		const firstPrimaryVariantId = parseInt( $firstPrimaryVariantIdInput.val(), 10 ) || 0;

		const $addToCartBtn = $form.find( this.addToCartSettings.addToCartBtnSelector );
		const $btnLabel = $addToCartBtn.find( '[data-submit-button-text]' );
		const $btnPriceLabels = $addToCartBtn.find( '[data-submit-button-price]' );

		$addToCartBtn.addClass( 'disabled' ).prop( 'disabled', true );
		$btnLabel.text( this.addToCartSettings.addingToCartBtnLabel );
		// now we need to understand if it's bundle, or upsell - tiered things just gets directy in cart as is :)
		const upsellType = this.$selectedBundleItem.attr( 'data-upsell-type' );
		const items2Add = [];

		if ( this.$selectedBundleItem.length ) {
			const variantIdsCsv = this.$selectedBundleItem.val();
			// lets replace firstPrimaryVariantId in variantIds to currentlySelected variant id.
			const variantIds = variantIdsCsv.split( ',' ).map( i => parseInt( i, 10 ) ).map( ( vid ) => {
				if ( vid === firstPrimaryVariantId ) {
					return currentProductVariantId;
				}
				return vid;
			} );

			if ( upsellType && ( upsellType === 'bundle' || upsellType === 'upsell' ) ) {
				if ( upsellType === 'bundle' ) {
					variantIds.forEach( ( varId ) => {
						items2Add.push( { variantId: varId, quantity } );
					} )
				} else {
					// it's upsell - set qty from quantity picker.
					items2Add.push( { variantId: variantIds[0], quantity } );
				}

			} else {
				// it's tiered product - set quantity set in qty picker.
				items2Add.push( { variantId: variantIds[0], quantity } );
			}
		} else {
			// just normal product
			items2Add.push( { variantId: currentProductVariantId, quantity } );
		}


		// lets map to array of promises and do When for all.
		console.log( items2Add );

		const self = this;
		const handleSuccess = () => {
			// Re-enable add to cart button.
			$addToCartBtn.addClass( 'inverted' );
			$btnLabel.text( this.addToCartSettings.addedToCartBtnLabel );

			// _showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$form);
			this.refresh();

			this.openWidget(); // uncomment to open widget when it's added.

			window.setTimeout( () => {

				$addToCartBtn.prop( 'disabled', false ).removeClass( 'disabled' ).removeClass( 'inverted' );
				$btnLabel.text( this.addToCartSettings.addToCartBtnLabel );
				$btnPriceLabels.fadeIn( 100 );

			}, this.addToCartSettings.howLongTillBtnReturnsToNormal );
			// Update cart count and show cart link.
		}
		const handleError = ( XMLHttpRequest ) => {
			// let response = eval('(' + XMLHttpRequest.responseText + ')');
			let response = JSON.parse( XMLHttpRequest.responseText );
			response = response.description;
			if ( response.slice( 0, 4 ) === 'All ' ) {
				// _showFeedback('error', response.replace('All 1 ', 'All '), $form);
				$addToCartBtn.prop( 'disabled', false );
				$btnLabel.text( this.addToCartSettings.soldOutBtnLabel );
				$addToCartBtn.prop( 'disabled', true );
			} else {

				// _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $form);
				$addToCartBtn.prop( 'disabled', false ).removeClass( 'disabled' );
				$btnLabel.text( this.addToCartSettings.addToCartBtnLabel );

			}
		}
		const promisesResults = [];
		const runQueue = () => {
			if ( items2Add.length ) {
				const item = items2Add.shift();
				const item_data = `id=${ item.variantId }&quantity=${ item.quantity }`;
				const promise = jQuery.ajax( {
					url: `${ self.BaseURL }/cart/add.js`,
					dataType: 'json',
					type: 'post',
					data: item_data,
					success: () => {
						promisesResults.push( promise );
						setTimeout( () => {
							runQueue();
						}, 500 )
					},
					error: ( err ) => {
						promisesResults.push( promise );
					}
				} );
			} else {
				Promise.allSettled( promisesResults ).then( handleSuccess, handleError );
			}
		}

		runQueue();

		/*
		// Add to cart.
		jQuery.ajax( {
			url: `${ this.BaseURL }/cart/add.js`,
			dataType: 'json',
			type: 'post',
			data: $form.serialize(),
			context: this,
			success: function ( itemData ) {
				// Re-enable add to cart button.
				$addToCartBtn.addClass( 'inverted' );
				$btnLabel.text( this.addToCartSettings.addedToCartBtnLabel );

				// _showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$form);
				this.refresh();

				this.openWidget(); // uncomment to open widget when it's added.

				window.setTimeout( () => {

					$addToCartBtn.prop( 'disabled', false ).removeClass( 'disabled' ).removeClass( 'inverted' );
					$btnLabel.text( this.addToCartSettings.addToCartBtnLabel );

				}, this.addToCartSettings.howLongTillBtnReturnsToNormal );
				// Update cart count and show cart link.

			},
			error: function ( XMLHttpRequest ) {
				// let response = eval('(' + XMLHttpRequest.responseText + ')');
				let response = JSON.parse( XMLHttpRequest.responseText );
				response = response.description;
				if ( response.slice( 0, 4 ) === 'All ' ) {
					// _showFeedback('error', response.replace('All 1 ', 'All '), $form);
					$addToCartBtn.prop( 'disabled', false );
					$btnLabel.text( this.addToCartSettings.soldOutBtnLabel );
					$addToCartBtn.prop( 'disabled', true );
				} else {

					// _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $form);
					$addToCartBtn.prop( 'disabled', false ).removeClass( 'disabled' );
					$btnLabel.text( this.addToCartSettings.addToCartBtnLabel );

				}
			}
		} );
		*/
		return false;
	}

	updateSubmitButtonUI( event ) {
		const $selected = jQuery( event.target );
		this.$selectedBundleItem = $selected;
		const $form = $selected.closest( 'form' );
		const $quantity = $form.find( 'input[name="quantity"]' );
		const $addToCartBtn = $form.find( this.addToCartSettings.addToCartBtnSelector );
		const $price = $addToCartBtn.find( this.addToCartSettings.addToCartBtnPriceSelector );

		const upsellType = $selected.attr( 'data-upsell-type' );
		const numberOfItems = parseInt( $selected.attr( 'data-number-of-items' ) || 1, 10 );

		// lets calculate button's caption price taking into account discounts and all the magic.

		// NB: prices are in cents, so we have to divide by 100
		const discountedTotal = parseFloat( $selected.attr( 'data-total-discounted' ) || 0 );
		const totalUndiscounted = parseInt( $selected.attr( 'data-total' ) || 0, 10 );

		// lets also take into account quantity set currently in our ui. and update it if it's tiered option.
		if ( upsellType === 'tiered' ) {
			$quantity.val( numberOfItems );
		} else {
			$quantity.val( 1 );
		}

		$price.html( this.getPriceHtml( totalUndiscounted, discountedTotal ) );
		// trigger refresh because we've changed it's value, it needs to get updated disabled state for +- btns.
		$quantity.trigger( 'wpshopify.quantityChanged.refresh' );

	}

	handleQuantityChange( event, quantity ) {
		const $quantity = jQuery( event.target );
		// lets in addition check if bundle variants have tiered ones- if it is, check if there's exact quantity, and assign it to be selected.
		let $selected = this.$selectedBundleItem;
		if ( $selected.length ) {
			const $form = $selected.closest( 'form' );
			const $addToCartBtn = $form.find( this.addToCartSettings.addToCartBtnSelector );
			const $price = $addToCartBtn.find( this.addToCartSettings.addToCartBtnPriceSelector );
			let numberOfItems = parseInt( $selected.attr( 'data-number-of-items' ) || 1, 10 );

			// if we have tiered selector, and currently selected one is tiered
			if ( this.$tieredOptions.length && this.$selectedBundleItem.attr( 'data-upsell-type' ) === 'tiered' ) {
				// check if there's a tier with exact quantity set
				const $tieredQuantityOption = this.$tieredOptions.filter( `[data-number-of-items="${ quantity }"]` );
				if ( $tieredQuantityOption.length ) {
					// if exact quantity tier exists, set it selected.
					this.$selectedBundleItem = $tieredQuantityOption;
					this.$bundleRadios.prop( 'checked', false )
					this.$selectedBundleItem.prop( 'checked', true );
					$selected = this.$selectedBundleItem;

				}
				// if exact tier isn't exists - put quantity with current tier.
				// we need to calculate all current quantity changes with current tier set!
				let discountedPerItem = parseFloat( $selected.attr( 'data-each-discounted' ) || 0 )
				let unDiscountedPerItem = parseFloat( $selected.attr( 'data-each-undiscounted' ) || 0 )
				let totalUnDiscounted = unDiscountedPerItem * quantity;
				let discountedTotal = discountedPerItem * quantity;
				$price.html( this.getPriceHtml( totalUnDiscounted, discountedTotal ) );

			} else {
				const upsellType = $selected.attr( 'data-upsell-type' );
				// lets calculate button's caption price taking into account discounts and all the magic.
				// NB: prices are in cents, so we have to divide by 100
				let discountedTotal = parseFloat( $selected.attr( 'data-total-discounted' ) || 0 );
				let totalUndiscounted = parseInt( $selected.attr( 'data-total' ) || 0, 10 );

				// lets also take into account quantity set currently in our ui. and update it if it's tiered option.
				if ( upsellType !== 'tiered' || ( upsellType === 'tiered' && numberOfItems === 1 ) ) {
					totalUndiscounted = totalUndiscounted * quantity;
					discountedTotal = discountedTotal * quantity
				}

				$price.html( this.getPriceHtml( totalUndiscounted, discountedTotal ) );
			}
		}
	}

	getPriceHtml( totalUndiscounted, discountedTotal ) {

		let fullPrice = ( totalUndiscounted / 100 ).toFixed( 2 ).replace( '.00', '' );//.replace( '.0', '' );
		let discountedPrice = ( discountedTotal / 100 ).toFixed( 2 ).replace( '.00', '' );//.replace( '.0', '' );

		if ( discountedTotal < totalUndiscounted ) {
			return `<s>$${ fullPrice }</s> <span>$${ discountedPrice }</span>`;
		} else {
			return `<span>$${ fullPrice }</span>`;
		}

	}

	refresh() {

		this.getJsonp( this.BaseURL + '/cart.json', ( cart ) => {

			// now have access to Shopify cart object
			console.log( 'There are now ' + cart.item_count + ' items in the cart.' );
			if ( cart.item_count ) {
				this.Counter = parseInt( cart.item_count, 10 );
				// lets render widget of products here
			} else {
				this.Counter = 0;
			}
			this.refreshWidget( cart );

		} );

	}

	getJsonp( url, callback ) {

		const callbackName = 'jsonp_callback_' + Math.round( 100000 * Math.random() );
		window[callbackName] = function ( data ) {
			delete window[callbackName];
			document.body.removeChild( script );
			callback( data );
		};

		const script = document.createElement( 'script' );
		script.src = url + ( url.indexOf( '?' ) >= 0 ? '&' : '?' ) + 'callback=' + callbackName;
		try {
			document.body.appendChild( script );
		} catch ( e ) {
			delete window[callbackName];
			document.body.removeChild( script );
		}


	}

	set Counter( value ) {
		this._counter = value;
		this.$counterEl.text( value );
		if ( this.$counterElLocalized ) {
			let localizedVal = this.formatItemCount( value );
			this.$counterElLocalized.text( localizedVal );
		}
	}

	get Counter() {
		return this._counter;
	}

	increment( by = 1 ) {
		this.Counter = this.Counter + parseInt( by, 10 );
	}

	decrement( by = 1 ) {
		this.Counter = this.Counter - parseInt( by, 10 );
	}

	formatMoney( value, removeZeros = false ) {

		value = parseInt( value );
		value = value / 100;
		let result = `$${ value }`;
		if ( removeZeros ) {
			result = result.replace( '.00', '' );
		}

		return result;

	}

	formatItemCount( value ) {
		return value < 1 ? 'Is Empty' : value === 1 ? '1 Item' : `${ value } Items`;
	}

	renderWidget() {

		const widgetHtml = `
<div class="cart-widget__block">
    <div class="cart-widget__inner">
        <a href="#" class="cart-widget__close" data-cart-widget-close title="Close">
            <span class="cart-widget__close-icon"></span>
            <span class="cart-widget__close-title">Your Bag</span>
            <span class="cart-widget__close-description">Close</span>
            <span class="cart-widget__close-items-count" data-cart-items-count-localized>Is Empty</span>
        </a> 
        <div class="cart-widget__items" data-cart-widget-items></div>
        <div class="cart-widget__also" data-cart-upsells></div>
        <div class="cart-widget__totals">
        
            <div class="cart-widget__totals-group">
                <div class="cart-widget__totals-line cart-widget__totals-line_subtotal">
                    <div class="cart-widget__totals-title">Subtotal</div>
                    <div class="cart-widget__totals-value" data-cart-subtotal>$0.00</div>
                </div>
                
                <div class="cart-widget__totals-line cart-widget__totals-line_shipping">
                    <div class="cart-widget__totals-title">Shipping</div>
                    <div class="cart-widget__totals-value">Calculated at the next Step</div>
                </div>
            </div>
            
            <div class="cart-widget__total">
                <div class="cart-widget__total-line">
                    <div class="cart-widget__total-title">Subtotal</div>
                    <div class="cart-widget__total-value" data-cart-total>$0.00</div>
                </div>
                <a href="${ this.BaseURL }/cart" class="btn btn-dark cart-widget__checkout-btn">Checkout</a>
            </div>
                
        </div>
    </div>
</div>`;

		this.$widget.html( widgetHtml );
		this.$itemsWrapper = jQuery( '[data-cart-widget-items]', this.$widget );
		this.$totalEl = jQuery( '[data-cart-total]' );
		this.$subtotalEl = jQuery( '[data-cart-subtotal]' );
		this.$counterElLocalized = jQuery( '[data-cart-items-count-localized]', this.$widget );
		this.$upsellsEl = jQuery( '[data-cart-upsells]', this.$widget );

		this.closeWidget( 0 );

	}

	renderCartItem( cartItem, lineNumber ) {
		console.log( 'cartItem', cartItem );
		let price = ''
		let originalPrice = '';
		if ( cartItem.discounted_price && cartItem.discounted_price < cartItem.price ) {
			price = this.formatMoney( cartItem.discounted_price, true );
			originalPrice = this.formatMoney( cartItem.price, true );
		} else {
			// normal undiscounted thing.
			price = this.formatMoney( cartItem.price, true );
		}

		let isVariantClassName = cartItem.product_has_only_default_variant ? '' : ' cart-widget__item_variant ';
		let isColorClassName = '';

		const priceToPayHtml = `<span class="cart-widget__item-price-value">${ price }</span>`;
		const crossedOutPriceHtml = originalPrice ? ` <s class="cart-widget__item-price-value">${ originalPrice }</s> ` : '';

		if ( cartItem.options_with_values && Array.isArray( cartItem.options_with_values ) ) {
			for ( let i = 0; i < cartItem.options_with_values.length; i++ ) {
				let optionName = cartItem.options_with_values[i]['name'];
				optionName = optionName.toLowerCase();
				if ( 'polish' === optionName || 'color' === optionName ) {
					isColorClassName = ' cart-widget__item_variant-color ';
				}
			}
			return `
<div class="cart-widget__item ${ isVariantClassName } ${ isColorClassName }" data-cart-item-id="${ cartItem.id }" data-cart-item-key="${ cartItem.key }">
    <div class="cart-widget__item-inner">
        <a class="cart-widget__item-image" href="${ this.BaseURL }${ cartItem.url }" style="background-image: url('${ cartItem.image }')"></a>
        <a class="cart-widget__item-title-col" href="${ this.BaseURL }${ cartItem.url }">
            <div class="cart-widget__item-title">${ cartItem.title }</div>
            <div class="cart-widget__item-quantity">
                <span class="cart-widget__item-quantity-title">QTY:</span>
                <span class="cart-widget__item-quantity-value">${ cartItem.quantity }</span>
            </div>
        </a>
        <div class="cart-widget__item-price-col">
            <div class="cart-widget__item-price">
                <span class="cart-widget__item-price-currency">US</span>
                ${ crossedOutPriceHtml }
                ${ priceToPayHtml }
            </div>
        </div>
        <a href="#" class="cart-widget__item-remove" data-remove-cart-item="${ lineNumber }" title="Remove ${ cartItem.title }" aria-label="Remove ${ cartItem.title } from cart"></a>
    </div>
</div>`;

		}
	}

	refreshWidget( cart ) {

		this.$subtotalEl.text( this.formatMoney( cart.items_subtotal_price ) );
		this.$totalEl.text( this.formatMoney( cart.total_price ) );

		// update items on cart.
		console.log( cart );

		let lineNumber = 1;
		let html = cart.items.reduce( ( html, cartItem ) => {
			html += this.renderCartItem( cartItem, lineNumber );
			lineNumber++;
			return html;
		}, '' );

		this.$itemsWrapper.html( html );

		if ( cart.total_price === 0 ) {
			this.closeWidget();
		}

	}


	toggleWidgetOpened( event ) {
		if ( this.$widget.hasClass( 'shown' ) ) {
			this.closeWidget();
		} else {
			this.openWidget();
		}
		event.preventDefault();
		return false;
	}

	handleCloseWidget( event ) {
		event.preventDefault();
		this.closeWidget();
		return false;
	}

	handleRemoveCartItem( event ) {
		event.preventDefault();
		const btnEl = event.currentTarget;
		if ( btnEl instanceof HTMLElement ) {
			const $cartItem = jQuery( btnEl ).closest( '.cart-widget__item' );
			let keyToRemove = btnEl.getAttribute( 'data-remove-cart-item' );
			jQuery( btnEl ).prop( 'disabled', true );

			btnEl.classList.add( 'spinning' );

			this.removeCartItem( keyToRemove ).done( () => {
				console.log( 'removed', keyToRemove );
				$cartItem.slideUp( CartCounter.animationTime, () => {
					$cartItem.remove();
					this.refresh();
				} );
			} ).fail( () => {
				console.warn( `CartRemovalItem Error` )
			} );
		}

	}

	handleAddToCartUpsell( event ) {
		event.preventDefault();
		const btnEl = event.currentTarget;
		if ( btnEl instanceof HTMLElement ) {

			let variantToAdd = btnEl.getAttribute( 'data-shopify-variant-id' );
			const $btn = jQuery( btnEl );
			$btn.prop( 'disabled', true );

			$btn.text( this.addToCartSettings.addingToCartBtnLabel );

			this.addCartItem( variantToAdd ).done( () => {
				console.log( 'added', variantToAdd );
				$btn.text( this.addToCartSettings.addedToCartBtnLabel );
				this.refresh();

				setTimeout( () => {
					this.$upsellsEl.fadeOut( CartCounter.animationTime, () => {
						this.$upsellsEl.removeClass( 'shown' );
						this.$itemsWrapper.removeClass( 'has-also' );
					} );
					// hide whole upsell item.
				}, this.addToCartSettings.howLongTillBtnReturnsToNormal );

			} ).fail( () => {
				console.warn( `AddCartItem Error` )
			} );
		}
	}

	handleAddToCart( event ) {
		event.preventDefault();
		const btnEl = event.currentTarget;
		if ( btnEl instanceof HTMLElement ) {

			if ( !btnEl.hasAttribute( 'data-available' ) ) {
				return;
			}

			let variantToAdd = btnEl.getAttribute( 'data-add-to-cart' );
			const $btn = jQuery( btnEl );
			const $btnCaption = $btn.find( '[data-submit-button-text]' );
			const $btnPrices = $btn.find( '[data-submit-button-price]' );

			$btn.prop( 'disabled', true );

			if ( $btnCaption.length ) {
				$btnCaption.text( this.addToCartSettings.addingToCartBtnLabel );
			} else {
				$btn.text( this.addToCartSettings.addingToCartBtnLabel );
			}

			this.addCartItem( variantToAdd ).done( () => {
				console.log( 'added', variantToAdd );
				if ( $btnCaption.length ) {
					$btnCaption.text( this.addToCartSettings.addedToCartBtnLabel );
				} else {
					$btn.text( this.addToCartSettings.addedToCartBtnLabel );
				}

				this.openWidget();
				this.refresh();

				setTimeout( () => {
					if ( $btnCaption.length ) {
						$btnCaption.text( this.addToCartSettings.addToCartBtnLabel );
					} else {
						$btn.text( this.addToCartSettings.addToCartBtnLabel );
					}
					$btn.prop( 'disabled', false );
				}, this.addToCartSettings.howLongTillBtnReturnsToNormal );

			} ).fail( () => {
				console.warn( `AddCartItem Error` )
			} );
		}
	}

	addCartItem( variantId, quantity = 1 ) {
		const defered = new jQuery.Deferred();

		const iframe = this.getCartIframe();

		try {
			iframe.onload = function () {
				defered.resolve();
			};

			iframe.onerror = function () {
				defered.reject( 'soldout' );
			}

			iframe.src = `${ this.BaseURL }/cart/add.js?id=${ variantId }&quantity=${ quantity }`;

		} catch ( e ) {
			defered.reject( e );
		}

		return defered.promise();
	}

	removeCartItem( key ) {
		return this.updateCartItemQuantity( key, 0 );
	}

	updateCartItemQuantity( id, quantity ) {

		// let route = '/cart/update.js';
		//
		// let data = {updates: {}};
		// data.updates[id] = quantity;
		//
		// if(this.isShopify){
		//
		//     return jQuery.post(`${this.BaseURL}${route}`, data);
		//
		// }else
		const defered = new jQuery.Deferred();

		const iframe = this.getCartIframe();

		try {
			iframe.onload = function () {
				defered.resolve();
			};

			iframe.src = `${ this.BaseURL }/cart/change.js?line=${ id }&quantity=${ quantity }`;

		} catch ( e ) {
			defered.reject( e );
		}

		return defered.promise();

	}

	openWidget( animationTime ) {
		let time = animationTime || CartCounter.animationTime;
		document.body.classList.add( 'cart-widget-shown' );
		this.$widget.slideDown( time, () => {
			this.$widget.addClass( 'shown' );
		} );
	}

	closeWidget( animationTime ) {

		let time = animationTime || CartCounter.animationTime;
		document.body.classList.remove( 'cart-widget-shown' );
		this.$widget.slideUp( time, () => {
			this.$widget.removeClass( 'shown' );
		} );
	}


	getCartIframe() {

		if ( !document.getElementById( 'hiddenCartIframe' ) ) {
			let addToCartIframe = document.createElement( 'iframe' );
			addToCartIframe.setAttribute( 'src', '' );//https://URL.com/cart/add
			addToCartIframe.setAttribute( 'id', 'hiddenCartIframe' );
			addToCartIframe.setAttribute( 'name', 'hiddenCartIframe' );
			addToCartIframe.setAttribute( 'style', 'height:1px;width:1px;position: absolute; z-index: -1;' );
			document.querySelector( 'body' ).appendChild( addToCartIframe );
		}

		return document.getElementById( 'hiddenCartIframe' )

	}

	initUpsells() {

		this.$upsellsEl.fadeOut( 0 );

		if ( Array.isArray( this.upsellHandles ) ) {
			// let's select one randomly and then load it and inject it's html.
			const productHandle = this.getRandomItem( this.upsellHandles );
			if ( productHandle ) {
				// lets load product item
				this.getJsonp( `${ this.BaseURL }/products/${ productHandle }.json`, ( response ) => {
					// render it...
					let upsellProductHtml = this.upsellProductTemplate( response.product );
					let upsellWidgetHtml = `
                    <div class="cart-widget__also-title">You may also like...</div>
                    <div class="cart-widget__also-product">
                        ${ upsellProductHtml }
                    </div>
                `;
					this.$upsellsEl.html( upsellWidgetHtml );
					this.$upsellsEl.fadeIn( CartCounter.animationTime, () => {
						this.$upsellsEl.addClass( 'shown' );
						this.$itemsWrapper.addClass( 'has-also' );
					} );


				} );
			}

		}
	}

	getRandomItem( handles ) {
		if ( Array.isArray( handles ) ) {
			handles.sort( () => Math.random() - 0.5 );
			return handles[0];
		}
		return null;
	}

	getSizedImageUrl( imageUrl, width ) {

		let sizedImageUrl = imageUrl;

		const imgUrlRegex = /(\S+)(\.[jpg][e]?[ipn][gf])(\S+)/gmi;

		width = Math.round( width );
		if ( width > 320 ) {
			width = 320;
		}

		if ( sizedImageUrl && sizedImageUrl.match( imgUrlRegex ) ) {
			const urlParts = imgUrlRegex.exec( imageUrl );
			sizedImageUrl = `${ urlParts[1] }_${ width }x${ width }${ urlParts[2] }${ urlParts[3] }`;
		}

		return sizedImageUrl;
	}

	upsellProductTemplate( product ) {
		let imageUrl = product.featured_image || product.image.src || '';
		imageUrl = this.getSizedImageUrl( imageUrl, 220 );
		const variantId = product.variants[0].id;
		let variantPrice = product.variants[0].price.replace( '.00', '' );

		return `            
            <div class="cart-widget__upsell-item" data-shopify-product-id="${ product.id }">
                <a href="${ this.BaseURL }${ product.url }" class="cart-widget__upsell-item-image" title="${ product.title }">
                    <img src="${ imageUrl }" alt="${ product.title }">
                </a>
                <a href="${ this.BaseURL }${ product.url }" class="cart-widget__upsell-item-title">${ product.title }</a>
                <a href="${ this.BaseURL }${ product.url }" class="cart-widget__upsell-item-btn" title="${ product.title }" 
                    data-shopify-variant-id="${ variantId }" data-add-upsell-to-cart >
                    <span class="cart-widget__upsell-item-btn-title">Add to bag -</span>
                    <span class="cart-widget__upsell-item-btn-currency">&dollar;</span><span class="cart-widget__upsell-item-btn-price">${ variantPrice }</span> 
                </a>
            </div>
        `;
	}


	static checkCompatibility() {
		jQuery( 'a.shopping-bag' ).each( ( index, el ) => {
			if ( !el.hasAttribute( 'data-cart-widget-toggle' ) ) {
				// update
				jQuery( el ).replaceWith( `<div class="CartCounter"><a href="//shop.miniluxe.com/cart" data-cart-widget-toggle class="shopping-bag"><span class="CartCounterValue">0</span></a>
                    <div class="cart-widget"></div>
                </div>` );
			}
		} );
	}

	static initialize() {
		window.WPShopify.Shop.CartCounter = new CartCounter();
	}


}

function Buffer( handler, finalHandler ) {
	var queue = [];

	function run() {
		var callback = function ( status, data ) {
			// when the handler says it's finished (i.e. runs the callback)
			// We check for more tasks in the queue and if there are any we run again
			if ( queue.length > 0 ) {
				run();
			} else {
				finalHandler( status, data );
			}
		}
		// give the first item in the queue & the callback to the handler
		handler( queue.shift(), callback );
	}

	// push the task to the queue. If the queue was empty before the task was pushed
	// we run the task.
	this.append = function ( task ) {
		queue.push( task );
		if ( queue.length === 1 ) {
			run();
		}
	}

}

jQuery( document ).ready( () => {
	CartCounter.checkCompatibility();
	CartCounter.initialize();
} )